import clone from 'clone'

// 企业模块的store
export default {
  /**
   * 如果模块名称为：company
   *  state: { ... }, // this.$store.state.company.xxx
      getters: {
        isAdmin () { ... } // -> this.$store.getters['company/isAdmin']
      },
      actions: {
        login () { ... } // -> this.$store.dispatch('company/login')
      },
      mutations: {
        login () { ... } // -> this.$store.commit('company/login')
      }
   */
  // 开启命名空间
  namespaced: true,
  state: {
    // 标准引用解析后的返回值
    /*
      {
        "author": [
          {
            "name": "孙水玲",
            "unit": "",
            "checked": false
          }
        ],
        "title": " 2类2-A'da'm自补有向环形网络[J]",
        "achievement_type": "QKLW",
        "doi": "10.3969/j.issn.1000-5854.2000.04.008."
      }
    */
  //  doi 解析后的返回值 就是比标准引用解析的返回值多一个关键字和归属单位
  /* {
      "achievement_type": "QKLW",
      "title": "计算机网络信息安全及防护策略探讨",
      "doi": "10.3969/j.issn.1672-7274.2015.10.112",
      "author": [
        {
          "name": "李浩",
          "unit": "",
          "checked": false
        }
      ],
      "keywords": "计算机网络信息安全防护策略",
      "subordinated_organization": "江苏省盐城市盐都区城市管理局数字化城市管理指挥中心,盐城,224005"
    } */

    // 解析后的返回值
    parseResult: null
    /* // doi解析值
    doiParseResult: null,
    // 标准引用解析值
    quoteParseResult: null */
  },
  mutations: {
    // 设置解析后的返回值
    SET_PARSE_RESULT (state, data) {
      state.parseResult = clone(data)
    },
    // 设置doi解析后的返回值
    SET_DOI_PARSE_RESULT (state, data) {
      state.doiParseResult = clone(data)
    },
    // 设置标准引用解析后的返回值
    SET_QUOTE_PARSE_RESULT (state, data) {
      state.quoteParseResult = clone(data)
    }
  },
  actions: {

  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/achievementParse.js